export default __webpack_public_path__ + "static/blueheader_img-dec8b7d9b3f211dab8808d4866a1f98d.png";